import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const checksubData = createAsyncThunk(
  'currentdata',
  async (checksubUrl) => {
    const response = await axios.get(checksubUrl,{
      headers:{
        Authorization:`Basic VGlja2hpZ2g6dGlja0hpZ2hAMjQj`
      }
    });
    return response.data;  // Return only the data part of the response
  }
);

export const checksubSlice = createSlice({
  name: "checksub",
  initialState: {
    checksub: null,
    status: 'idle',
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(checksubData.pending, (state) => {
      state.status = 'loading';
    })
    .addCase(checksubData.fulfilled, (state, action) => {
      state.status = 'succeeded';
      state.checksub = {
        name: action.payload.name, 
        value: action.payload.name
      };
    })
    .addCase(checksubData.rejected, (state, action) => {
      state.status = 'failed';
      state.error = action.error.message;
    });
  }
});

export const { reset } = checksubSlice.actions;
export default checksubSlice.reducer;